import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-toaster',
  templateUrl: './custom-toaster.component.html',
  styleUrls: ['./custom-toaster.component.scss'],
  animations: [
    trigger('animationOption2', [
      state(
        'close',
        style({
          display: 'none',
          opacity: 0,
          backgroundColor: 'white',
        })
      ),
      state(
        'open',
        style({
          display: 'block',
          opacity: 1,
          backgroundColor: '#00a889',
        })
      ),
      transition('close <=> open', animate(1000)),
    ]),
  ],
})
export class CustomToasterComponent implements OnInit {
  @Input('isShowToaster')
  set customerData(data: any) {
    if (data === 'show') {
      this.showToaster = true;
    } else {
      this.showToaster = false;
    }
  }
  @Input() toasterOpts: any;

  @Output() actionClicked = new EventEmitter();
  @Output() onCloseToaster = new EventEmitter();

  private subscription: Subscription;
  private timer: Observable<any>;
  showToaster: boolean = false;

  constructor() {}

  ngOnInit() {}

  clickAction(action) {
    this.actionClicked.emit({ action, data: this.toasterOpts.data });
  }

  close() {
    this.showToaster = false;
    this.onCloseToaster.emit();
  }
}
